import { render, staticRenderFns } from "./siderbarItem.vue?vue&type=template&id=59b83e1e&scoped=true"
import script from "./siderbarItem.vue?vue&type=script&lang=js"
export * from "./siderbarItem.vue?vue&type=script&lang=js"
import style0 from "./siderbarItem.vue?vue&type=style&index=0&id=59b83e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b83e1e",
  null
  
)

export default component.exports